module.exports = __webpack_public_path__ + "assets/img/S.44cd3320.png";